/**
 * @param {vueInstance} context - This
 * @returns {Section}
 */
export default function (context) {
  const { id, demo } = context.item
  return {
    key: 'project_page_section',
    resource: '',
    type: 'Section',
    title: {
      id: 'project_page_section',
      label: context.$t('addon:project:presentation'),
      icon: '',
      style: '',
    },
    border: false,
    actions: ({ data, source }) => {
      if (demo) return []
      return [
        {
          id: 'project_page_external',
          label: `${context.$t('showAll')} ${context.$t('statistics').toLowerCase()}`,
          icon: ['fal', 'arrow-to-right'],
          type: 'button',
          tag: 'router-link',
          theme: 'primary',
          to: {
            name: 'analytics-external',
            params: { id: id },
            query: { type: context.type, ...context.$route.query },
          },
        },
      ]
    },
  }
}
